<template>
  <div class="switch">
    <div class="switch__content">
      <ProjectsMandatorySwitch
        v-if="hasRole('company', 'ROLE_GET_COMPANY_ID_CONFIG')"
        :data="dataObject"
        class="switch__item--border"
        @update="updateDataObject"
      />
    </div>
  </div>
</template>

<script>
import { hasRole } from 'utils/functions'
import ProjectsMandatorySwitch from 'components/company/ProjectsMandatorySwitch'

export default {
  name: 'ProjectsMandatory',
  props: {
    data: {
      type: Object,
      default: () => {}
    }
  },
  components: {
    ProjectsMandatorySwitch
  },
  data () {
    return {
      dataObject: null
    }
  },
  methods: {
    hasRole (group, role) {
      return hasRole(group, role)
    },

    setDataObject (val = {}) {
      this.dataObject = { ...val }
    },

    updateDataObject (obj = {}) {
      this.dataObject = {
        ...this.data,
        ...this.dataObject,
        ...obj
      }
    }
  },
  watch: {
    data: {
      deep: true,
      handler (val) {
        this.setDataObject(val)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.switch {
  margin-bottom: 24px;
  padding: 0 16px;
}

.switch__content {
  background-color: #fff;
  border: 1px solid $gray-2;
  max-width: 840px;
  transition: box-shadow .26s;

  &:hover {

    @media (min-width: 992px) {
      box-shadow: 0 1px 6px rgba(#000, .25);
    }
  }
}

.switch__item--border {
  border-bottom: 1px solid $gray-2;
}
</style>
